import React from "react";
import { Placeholder } from "react-bootstrap";

function RevenueReportTable(props) {
  if (props.error) {
    return <p>Error: {props.error}</p>;
  }

  return (
    <div style={{ fontSize: 14, color: "#000" }}>
      <div
        className="w-100 mt-3 border d-flex rounded-top"
        style={{ background: "#F9FAFD" }}
      >
        {props.columns?.map((field) => {
          return (
            <th className="p-2 text-center flex-1">
              <span>{field}</span>
            </th>
          );
        })}
      </div>
      {props.isLoading ? (
        <div>
          <Placeholder as="p" animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
          <Placeholder as="p" animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
          <Placeholder as="p" animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
          <Placeholder as="p" animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        </div>
      ) : (
        props.revenueData?.map((coach, index) => {
          return (
            <div
              style={{ background: "#fff" }}
              className={`w-100 d-flex border border-top-0 py-2 ${
                index === props.revenueData.length - 1 ? "rounded-bottom" : ""
              }`}
            >
              <td className="text-center flex-1 text-break">
                <span>{coach?.hairCoach}</span>
              </td>
              <td className="p-0 flex-1 d-flex flex-column">
                <tr className="text-center flex-1">
                  <span>count</span>
                </tr>
                <tr className="text-center flex-1">
                  <span>amount</span>
                </tr>
              </td>
              {coach.amount &&
                Object.keys(coach?.amount)?.map((field) => {
                  return (
                    <td className="flex-1 d-flex flex-column" key={field}>
                      <tr className="flex-1 d-flex justify-content-end px-4">
                        <span>{coach?.count[field]}</span>
                      </tr>
                      <tr className="flex-1 d-flex justify-content-end px-4">
                        <span>{coach?.amount[field]}</span>
                      </tr>
                    </td>
                  );
                })}
            </div>
          );
        })
      )}
    </div>
  );
}

export default RevenueReportTable;
